export default __webpack_public_path__ + "static/media/downloadbtn.eaabb71c.png";